angular.module('lsnBase.deprecated.models')
  .factory('InstallmentModelV1', ['LsnInstallmentModelV1',
    function(LsnInstallmentModelV1) {
      return LsnInstallmentModelV1;
    }
  ]);